import { ChevronRight } from "lucide-react";
import { SectionEyebrow } from "@/components/Landing/primitives";

const STEPS = Object.freeze([
    {
        n: "01",
        title: "Configure your project.",
        body: "Map project structure, contractor packages, role matrices, access rules. Pre-built templates for civil, energy, BESS, tunnelling, and building.",
    },
    {
        n: "02",
        title: "Onboard your supply chain.",
        body: "Invite subcontractors via the portal. Workers self-onboard with credential uploads. AI classifies and extracts. Compliance status is live before a single boot hits the ground.",
    },
    {
        n: "03",
        title: "Open the gate.",
        body: "Site access kiosks go live. Plant is registered. Permits, SWMS, and inductions flow through Edara. Group HSE has a real-time picture by project, by package, by trade.",
    },
    {
        n: "04",
        title: "Govern at scale.",
        body: "Dashboards roll up to project, region, and group level. Findings, incidents, and corrective actions tracked to closure. Audit-ready at any moment.",
    },
]);

export default function HowItWorks() {
    return (
        <section
            id="how"
            className="relative py-24 sm:py-32 bg-white text-[#0A0A0A]"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl reveal">
                    <SectionEyebrow>How it works</SectionEyebrow>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1] mt-3">
                        From kick-off to operational in weeks, not quarters.
                    </h2>
                </div>

                <ol className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
                    {STEPS.map((s) => (
                        <li
                            key={s.n}
                            className="reveal relative rounded-2xl bg-[#F8FAFC] border border-zinc-200 p-6"
                        >
                            <div className="flex items-center justify-between">
                                <div className="font-display text-5xl text-[#0A0A0A]">
                                    {s.n}
                                </div>
                                <div className="w-9 h-9 rounded-full bg-[#1FA8FF]/10 text-[#1FA8FF] flex items-center justify-center">
                                    <ChevronRight className="w-5 h-5" />
                                </div>
                            </div>
                            <h3 className="mt-5 font-sora font-semibold text-lg text-[#0A0A0A] leading-tight">
                                {s.title}
                            </h3>
                            <p className="mt-3 text-[14px] text-zinc-600 leading-relaxed">
                                {s.body}
                            </p>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
}
